module.exports = __webpack_public_path__ + "static/media/map_bg.1a8580dc.png";